import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import dayjs from "dayjs";

const FinesHistory = ({ onChange }) => {
  const initialFineHistoryRow = {
    Custodian: "",
    Fine_Date: "",
    Paid_Date: "",
    Amount: "",
    Location: "",
    Date_Time: "",
    Remarks: "",
  };
  const [fineHistory, setFineHistory] = useState([initialFineHistoryRow]);

  const [base_url] = useState(base_url_from_axios_config);

  const location = useLocation();
  useEffect(() => {
    if (location.state?.item) {
      const registrationNumber = location.state?.item.REG_NO;
      fetchVehicleFine(registrationNumber);
    }
  }, [location.state]);

  const fetchVehicleFine = async (regNo) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray[0]?.cmpcode || null;
    try {
      if (!regNo) return;

      const apiURL = `${base_url}/api/CpaysCount/${companyCode}/VEHICLEFINESINGLE/${regNo}/-`;

      const response = await axios.get(apiURL);

      const data = response?.data || [];

      console.log("Vehicle fine data:", data);

      setFineHistory(data);
      onChange(data)
    } catch (error) {
      console.error("Error fetching vehicle fine:", error);
    }
  };

  const onAddRow = () => {
    const updated = [...fineHistory, initialFineHistoryRow];
    setFineHistory(updated);
    // onChange(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...fineHistory];
    updated[index][field] = value;
    setFineHistory(updated);

    onChange(updated);
  };

  const onDeleteRow = (index) => {
    const updated = fineHistory.filter((_, i) => i !== index);
    setFineHistory(updated);
    onChange(updated);
  };

  return (
    <div>
      <table className="min-w-full bg-white rounded-sm border border-[gray-300] text-xs">
        <thead>
          <tr className="bg-[#2663EB] text-white text-sm">
            <th className="px-2 py-1 font-semibold">Sl No</th>
            <th className="px-2 py-1 font-semibold">Custodian</th>
            <th className="px-2 py-1 font-semibold">Fine Date</th>
            <th className="px-2 py-1 font-semibold">Paid Date</th>
            <th className="px-2 py-1 font-semibold">Amount</th>
            <th className="px-2 py-1 font-semibold">Location</th>
            <th className="px-2 py-1 font-semibold">Date Time</th>
            <th className="px-2 py-1 font-semibold">Remarks</th>
            <th className="px-2 py-1 font-semibold text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {fineHistory.map((row, index) => (
            <tr key={index}>
              <td className="border">
                <div className="flex gap-2 pl-2">{index + 1}</div>
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.Custodian || ""}
                  onChange={(e) =>
                    handleChange(index, "Custodian", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="date"
                  value={
                    row.Fine_Date || dayjs(row.FDate).format("YYYY-MM-DD") || ""
                  }
                  onChange={(e) =>
                    handleChange(index, "Fine_Date", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>
              <td className="border">
                <input
                  type="date"
                  value={
                    row.Paid_Date || dayjs(row.PDate).format("YYYY-MM-DD") || ""
                  }
                  onChange={(e) =>
                    handleChange(index, "Paid_Date", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.Amount || ""}
                  onChange={(e) =>
                    handleChange(index, "Amount", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.Location || ""}
                  onChange={(e) =>
                    handleChange(index, "Location", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="date"
                  value={
                    row.Date_Time || dayjs(row.DDate).format("YYYY-MM-DD") || ""
                  }
                  onChange={(e) =>
                    handleChange(index, "Date_Time", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.Remarks || ""}
                  onChange={(e) =>
                    handleChange(index, "Remarks", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border text-center">
                <button
                  type="button"
                  onClick={onAddRow}
                  className="px-3 py-1.5 mr-2 text-xs font-semibold rounded-xl bg-green-600 hover:bg-green-700 text-white"
                >
                  Add Row
                </button>

                {fineHistory.length > 1 && (
                  <button
                    type="button"
                    onClick={() => onDeleteRow(index)}
                    className="px-3 py-1.5 text-xs font-semibold rounded-xl bg-red-500 hover:bg-red-600 text-white"
                  >
                    Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FinesHistory;
